import NetInfo from '@react-native-community/netinfo'

import { useToast } from '@/src/general/components/ToastContext'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

import { Button, type TDefaultButtonProps } from '../default'

export const ConnectedButton = ({ ref, onPress, ...otherProps }: TDefaultButtonProps) => {
  const { isInternetReachable } = NetInfo.useNetInfo()
  const { addToast } = useToast()
  const { t } = useTranslate()

  const onDisconnectedPress = () => {
    addToast({
      message: t('app-service.not-connected'),
      colors: 'danger',
      iconName: ICON.WIFI_OFF,
    })
  }

  return (
    <Button
      ref={ref}
      isInactive={!isInternetReachable}
      onPress={isInternetReachable ? onPress : onDisconnectedPress}
      {...otherProps}
    />
  )
}

ConnectedButton.displayName = 'ConnectedButton'
